module.exports = __webpack_public_path__ + "img/cooling.7e8cdfdf.jpg";